/*
 * File Created: Tuesday, 3rd January 2023 11:20:35 am
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */
import React from 'react';
import Fab from '@mui/material/Fab';
import { BsArrowUp } from 'react-icons/bs';
import { theme } from '../../theme/theme';
import { Slide, useScrollTrigger } from '@mui/material';
import { useScroll } from '../../utils/useScroll';
import { Colors } from "../../constants/color";
// import { Theme, useTheme } from '@mui/material';

function ScrollToTop(): JSX.Element {
  const threshold = useScrollTrigger({
    disableHysteresis: true,
    threshold: 450,
  });

  return (
    <Slide direction='up' in={threshold} mountOnEnter unmountOnExit>
      <Fab
        sx={{
          width: theme.typography.pxToRem(50),
          height: theme.typography.pxToRem(50),
          borderRadius: 0,
          backgroundColor: Colors.alabaster,
          color: Colors.dusty_gray,
          fontSize: theme.typography.pxToRem(30),
        }}
        onClick={useScroll('toTop')}
      >
        <BsArrowUp />
      </Fab>
    </Slide>
  );
};

export default ScrollToTop;
